import type { QueryClient } from '@tanstack/react-query';
import { adminKeys } from './query-keys';

/**
 * GECERSIZ KILMA — TEK YER.
 *
 * Mutasyonlarin her biri kendi `invalidateQueries` cagrilarini yazsaydi, yeni
 * bir liste eklendiginde bazi mutasyonlarin unutulmasi kacinilmaz olurdu ve bu
 * hicbir yerde HATA VERMEZ: liste sessizce bayat kalir, kullanici "yaptim ama
 * gorunmuyor" der. Bu yuzden gecersiz kilma haritasi query-keys.ts'te YAZILI
 * ve uygulamasi burada, uc adet fonksiyonda toplaniyor.
 *
 * KABA DAVRANILIYOR: bir kullanici degistiginde isletme detayi da tazeleniyor
 * (o kullanici orada bir uye satiri). Fazladan bir istek, gorunmeyen bir
 * degisiklikten ucuzdur.
 */

/**
 * Kullanici uzerinde yapilan HER islem (durum, rol, sifre sifirlama).
 *
 * `metricsUsersRoot` de dahil: `totals` CANLI bir goruntu ve aktif/pasif
 * sayilari bu islemle ayni anda degisiyor.
 */
export const invalidateAfterUserMutation = async (
  queryClient: QueryClient,
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: adminKeys.usersRoot() }),
    // Isletme detayindaki uye satiri ayni kullaniciyi gosteriyor.
    queryClient.invalidateQueries({ queryKey: adminKeys.organizationsRoot() }),
    // Sunucu her islem icin denetim kaydi yaziyor (organizationId: null).
    queryClient.invalidateQueries({ queryKey: adminKeys.auditRoot() }),
    queryClient.invalidateQueries({ queryKey: adminKeys.metricsUsersRoot() }),
  ]);
};

/** Isletme aktifligi — uyelerin jetonlari da iptal ediliyor. */
export const invalidateAfterOrganizationMutation = async (
  queryClient: QueryClient,
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: adminKeys.organizationsRoot() }),
    // Kullanici listesi isletme adini ve uyelik durumunu gosteriyor.
    queryClient.invalidateQueries({ queryKey: adminKeys.usersRoot() }),
    queryClient.invalidateQueries({ queryKey: adminKeys.auditRoot() }),
    // totals.activeOrganizations degisiyor.
    queryClient.invalidateQueries({ queryKey: adminKeys.metricsUsersRoot() }),
  ]);
};

/**
 * Duyuru gonderimi. Denetim kaydina YAZILMAZ (kayit currency servisinde ayri
 * bir tabloda), bu yuzden yalniz gecmis listesi tazelenir.
 */
/**
 * Isletme banka hesabi yazildiktan sonra.
 *
 * Hesap listesi `organizationsRoot()` altinda oldugu icin isletme mutasyonunun gecersiz
 * kilmasi bunu ZATEN kapsiyor; yine de ayri bir yardimci var ki cagri yerinde "neyi
 * tazeliyorum" sorusu okunur olsun. Denetim kaydi da tazeleniyor: sunucu her hesap
 * yazmasi icin adminAccountCreated/Updated satiri birakiyor.
 */
export const invalidateAfterAccountMutation = async (
  queryClient: QueryClient,
  organizationId: string,
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: adminKeys.organizationAccounts(organizationId) }),
    queryClient.invalidateQueries({ queryKey: adminKeys.auditRoot() }),
  ]);
};

export const invalidateAfterBroadcast = async (queryClient: QueryClient): Promise<void> => {
  await queryClient.invalidateQueries({ queryKey: adminKeys.broadcasts() });
};

/** Uyarili islem kapatildi: satir kuyruktan duser, pazaryeri sayilari degisir. */
export const invalidateAfterTaskResolve = async (queryClient: QueryClient): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: adminKeys.warnedTasksRoot() }),
    queryClient.invalidateQueries({ queryKey: adminKeys.metricsRoot() }),
    queryClient.invalidateQueries({ queryKey: adminKeys.activity() }),
  ]);
};
